import axios from 'axios';
import * as moment from 'moment';

import config from '../utils/config';

import {
  authIdInputValue$,
  emailInputValue$,
} from '../selectors/findUser';

import { currentProductName$ } from '../selectors/product';

import * as UserExplorerActions from '../actions/userExplorer';

import ReduxAction from '../interfaces/ReduxAction';

const URL = config().userExplorer;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const userExplorer = (date: Date | moment.Moment): ReduxAction => {
  return (dispatch, getState): void => {
    dispatch(UserExplorerActions.fetchUserExplorerPendingAction());
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }

    paramsAppender('customer_id', authIdInputValue$(getState()));
    paramsAppender('customer_email', emailInputValue$(getState()));
    paramsAppender('product', currentProductName$(getState()));
    paramsAppender('date', moment(date).format('YYYY-MM-DD'));

    axios({
      method: 'post',
      url: URL,
      data: params,
    })
      .then(response => {
        dispatch(UserExplorerActions.fetchUserExplorerSuccessAction(response.data));
      })
      .catch(error => {
        // @ts-ignore
        dispatch(UserExplorerActions.fetchUserExplorerErrorAction(error));
      });
  };
};
